﻿export class ContragentPolygon {
	isBase: boolean;
	coordinates: number[][] = [];
}
